import { ROUTES } from '~/src/navigation/routes'

import { UserRole } from '~/__generated_types__/globalTypes'

import { SidebarItem } from '~/src/navigation/types'

export const NEW_NAV_FF = 'allowNewUserWorkflows'

export const SIDEBAR_ITEMS: Array<SidebarItem> = [
  {
    kind: 'link',
    key: 'home',
    title: ROUTES.home.title,
    href: ROUTES.home.href,
    icon: 'HouseLineIcon',
    featureFlag: NEW_NAV_FF,
  },
  {
    kind: 'menu',
    key: 'plan',
    title: ROUTES.plan.title,
    icon: 'PaperPlaneTiltIcon',
    featureFlag: NEW_NAV_FF,
    items: [
      {
        key: 'load-entry',
        icon: 'PencilSimpleLineIcon',
        title: ROUTES.plan.children.loadEntry.title,
        subTitle: ROUTES.plan.children.loadEntry.subTitle,
        href: ROUTES.plan.children.loadEntry.href,
      },
      {
        key: 'timeline',
        icon: 'CalendarDotsIcon',
        featureFlag: 'showPlanningBoardToOperator',
        title: ROUTES.plan.children.timeline.title,
        subTitle: ROUTES.plan.children.timeline.subTitle,
        href: ROUTES.plan.children.timeline.href,
      },
    ],
  },
  {
    kind: 'menu',
    key: 'monitor',
    title: ROUTES.monitor.title,
    icon: 'RoadHorizonIcon',
    featureFlag: NEW_NAV_FF,
    items: [
      {
        key: 'active-loads',
        icon: 'RoadHorizonIcon',
        title: ROUTES.monitor.children.activeLoads.title,
        subTitle: ROUTES.monitor.children.activeLoads.subTitle,
        href: ROUTES.monitor.children.activeLoads.href,
      },
      {
        key: 'driver-visibility',
        icon: 'TruckIcon',
        title: ROUTES.monitor.children.driverVisibility.title,
        subTitle: ROUTES.monitor.children.driverVisibility.subTitle,
        href: ROUTES.monitor.children.driverVisibility.href,
      },
      {
        key: 'active-exceptions',
        icon: 'ShieldWarningIcon',
        featureFlag: 'enableActiveExceptionsDashboard',
        title: ROUTES.monitor.children.activeExceptions.title,
        subTitle: ROUTES.monitor.children.activeExceptions.subTitle,
        href: ROUTES.monitor.children.activeExceptions.href,
      },
    ],
  },
  {
    kind: 'menu',
    key: 'review',
    title: ROUTES.review.title,
    icon: 'PenNibIcon',
    featureFlag: NEW_NAV_FF,
    items: [
      {
        key: 'signoff',
        icon: 'PenNibIcon',
        title: ROUTES.review.children.signoff.title,
        subTitle: ROUTES.review.children.signoff.subTitle,
        href: ROUTES.review.children.signoff.href,
      },
      {
        key: 'efficiency-management',
        icon: 'TrendUpIcon',
        title: ROUTES.review.children.efficiencyManagement.title,
        subTitle: ROUTES.review.children.efficiencyManagement.subTitle,
        href: ROUTES.review.children.efficiencyManagement.href,
        featureFlag: 'showEfficiencyManagmentDashbaord',
      },
    ],
  },
  {
    kind: 'menu',
    key: 'data',
    title: ROUTES.data.title,
    icon: 'ListBulletsIcon',
    items: [
      {
        key: 'facilities',
        icon: 'WarehouseIcon',
        featureFlag: 'showFacilityManagement',
        title: ROUTES.data.children.facilities.title,
        href: ROUTES.data.children.facilities.href,
      },
      {
        key: 'equipment',
        icon: 'TruckTrailerIcon',
        featureFlag: 'showEquipmentManagement',
        title: ROUTES.data.children.equipment.title,
        href: ROUTES.data.children.equipment.href,
      },
      {
        key: 'all-loads',
        title: ROUTES.allLoads.title,
        href: ROUTES.allLoads.href,
        icon: 'ArticleIcon',
      },
    ],
  },
  {
    kind: 'link',
    key: 'Admin',
    title: 'Admin',
    icon: 'UserGearIcon',
    href: '/admin-control-center',
    allowedRoles: [UserRole.Sysadmin],
    // featureFlag: 'showAdmin',
  },
  {
    kind: 'action',
    key: 'settings',
    title: 'Settings',
    icon: 'GearSixIcon',
    action: 'settings',
  },
  {
    kind: 'action',
    key: 'logout',
    title: 'Log out',
    icon: 'SignOutIcon',
    action: 'logout',
  },
]
